import { Injectable } from '@angular/core';
import { IsbExperience } from '@nationwide/dgs-angular-billing-common';

import { CCAuthorizationAgreementParams, EFTAuthorizationAgreementParams } from '../../../../../../shared/payments/ez-pay-authorization/easy-pay-authorization-agreement.service';
import { DistributedDocumentsResponseModel } from '../../../../../../shared/payments/ez-pay-authorization/eft-authorization-form/model/distributed-documents-response.model';
import { PaymentFormGroup } from '../../../../../../shared/payments/payment-form-group';
import { PaymentItem } from '../../../../shared/models/payment-item.model';
import { EditAutomaticPaymentResponse } from '../review/edit-automatic-payments-review.service';

@Injectable()
export class EditAutomaticPaymentFlowService {
    editAutomaticPaymentForm: PaymentFormGroup;
    editAutomaticPaymentResponse: EditAutomaticPaymentResponse;
    billingAccountHolderName: string;
    amountDue: string;
    nextBillDueDate: Date;
    currentBillDueDate: Date;
    emailAddress: string;
    billingAccountNumber: string;
    selectedPayMethod: PaymentItem;
    currentBillingMethodType: IsbExperience.GetPayPlanResponse['billingMethodType'];
    originalPaymentMethod: PaymentItem;
    successfullyUpdatedEnrollment: boolean;
    automaticPaymentSuspended: boolean;
    billedStatus: boolean;
    billingStreet1: string;
    billingCity: string;
    billingState: string;
    canCancelOrSuspendAutomaticPayments: boolean;
    distributedDocumentsResponseModel: DistributedDocumentsResponseModel;
    authorizationAgreementParams: EFTAuthorizationAgreementParams | CCAuthorizationAgreementParams;
    isLifeOnlyAccount: boolean;
    canPayNow = false;
    hasCreditCardVulPolicyError: boolean;
    paymentPlan: string;
    errorDetails: {
        errorMessage: string;
        errorCode: number;
    };
    wasRecurringAuthorizationFormSuccessfullySaved: boolean;

    get flowInPlay(): boolean {
        return this.editAutomaticPaymentForm != null;
    }

    save(params: Partial<EditAutomaticPaymentFlowService>): void {
        this.editAutomaticPaymentForm = params.editAutomaticPaymentForm || this.editAutomaticPaymentForm;
        this.billingAccountHolderName = params.billingAccountHolderName || this.billingAccountHolderName;
        this.amountDue = params.amountDue || this.amountDue;
        this.canPayNow = params.canPayNow || this.canPayNow;
        this.nextBillDueDate = params.nextBillDueDate || this.nextBillDueDate;
        this.currentBillDueDate = params.currentBillDueDate || this.currentBillDueDate;
        this.emailAddress = params.emailAddress || this.emailAddress;
        this.billingAccountNumber = params.billingAccountNumber || this.billingAccountNumber;
        this.selectedPayMethod = params.selectedPayMethod || this.selectedPayMethod;
        this.originalPaymentMethod = params.originalPaymentMethod || this.originalPaymentMethod;
        this.currentBillingMethodType = params.currentBillingMethodType || this.currentBillingMethodType;
        this.successfullyUpdatedEnrollment = params.successfullyUpdatedEnrollment ?? this.successfullyUpdatedEnrollment;
        this.automaticPaymentSuspended = params.automaticPaymentSuspended ?? this.automaticPaymentSuspended;
        this.billedStatus = params.billedStatus ?? this.billedStatus;
        this.billingStreet1 = params.billingStreet1 || this.billingStreet1;
        this.billingCity = params.billingCity || this.billingCity;
        this.billingState = params.billingState || this.billingState;
        this.distributedDocumentsResponseModel = params.distributedDocumentsResponseModel || this.distributedDocumentsResponseModel;
        this.authorizationAgreementParams = params.authorizationAgreementParams || this.authorizationAgreementParams;
        this.isLifeOnlyAccount = params.isLifeOnlyAccount;
        this.editAutomaticPaymentResponse = params.editAutomaticPaymentResponse || this.editAutomaticPaymentResponse;
        this.hasCreditCardVulPolicyError = params.hasCreditCardVulPolicyError ?? this.hasCreditCardVulPolicyError;
        this.paymentPlan = params.paymentPlan || this.paymentPlan;
        this.canCancelOrSuspendAutomaticPayments = params.canCancelOrSuspendAutomaticPayments ?? this.canCancelOrSuspendAutomaticPayments;
        this.errorDetails = params.errorDetails || this.errorDetails;
        this.wasRecurringAuthorizationFormSuccessfullySaved = params.wasRecurringAuthorizationFormSuccessfullySaved ?? this.wasRecurringAuthorizationFormSuccessfullySaved;
    }

    clear(): void {
        this.editAutomaticPaymentForm = undefined;
        this.selectedPayMethod = undefined;
        this.originalPaymentMethod = undefined;
        this.billingAccountHolderName = undefined;
        this.amountDue = undefined;
        this.nextBillDueDate = undefined;
        this.currentBillDueDate = undefined;
        this.emailAddress = undefined;
        this.billingAccountNumber = undefined;
        this.currentBillingMethodType = undefined;
        this.successfullyUpdatedEnrollment = undefined;
        this.billedStatus = undefined;
        this.billingStreet1 = undefined;
        this.billingCity = undefined;
        this.billingState = undefined;
        this.isLifeOnlyAccount = undefined;
        this.canPayNow = undefined;
        this.emailAddress = undefined;
        this.automaticPaymentSuspended = undefined;
        this.hasCreditCardVulPolicyError = undefined;
        this.paymentPlan = undefined;
        this.errorDetails = undefined;
        this.canCancelOrSuspendAutomaticPayments = undefined;
        this.wasRecurringAuthorizationFormSuccessfullySaved = undefined;
    }
}
